"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserVisibility = exports.PreferenceTypes = void 0;
var PreferenceTypes;
(function (PreferenceTypes) {
    PreferenceTypes["ETICKET"] = "eticket";
})(PreferenceTypes || (exports.PreferenceTypes = PreferenceTypes = {}));
var UserVisibility;
(function (UserVisibility) {
    UserVisibility["AUTHORIZED"] = "authorized";
    UserVisibility["AUTHORIZED_AND_SOFT_LOGGED_IN"] = "authorized_and_soft_logged_in";
    UserVisibility["EVERYONE"] = "everyone";
})(UserVisibility || (exports.UserVisibility = UserVisibility = {}));
//# sourceMappingURL=AccountTypes.js.map